import { useEffect, useState } from "react";

const GRACE_MS = 15 * 60 * 1000; // keep "any moment now" for 15 min past the start

export function countdownLabel(ms) {
  if (ms == null) return null;
  if (ms <= 0) return "Starting any moment now";
  const total = Math.ceil(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `Starting in ${h} h ${String(m).padStart(2, "0")} min`;
  return `Starting in ${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/** Milliseconds until `targetIso` (ticks every second); null when unset/invalid or long past. */
export function useCountdown(targetIso) {
  const target = targetIso ? new Date(targetIso).getTime() : NaN;
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (Number.isNaN(target)) return undefined;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);
  if (Number.isNaN(target)) return null;
  const ms = target - now;
  return ms < -GRACE_MS ? null : ms;
}

export function CountdownPill({ targetIso, theme }) {
  const ms = useCountdown(targetIso);
  const label = countdownLabel(ms);
  if (!label) return null;
  return (
    <div
      style={{ color: theme.text, fontSize: 26, fontWeight: 700, marginTop: 26, padding: "10px 30px", borderRadius: 999, border: `2px solid ${theme.accent}`, letterSpacing: 1, fontVariantNumeric: "tabular-nums" }}
      data-testid="holding-countdown" data-ms={Math.max(0, ms)}
    >
      {label}
    </div>
  );
}

export default CountdownPill;
